module.exports = __webpack_public_path__ + "images/logo@3x---4c570e950665a547649b226c4aeceace.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo@3x.png
// module id = 355
// module chunks = 0